import { forwardRef } from 'react';
import { classNames } from '~/utils/styles';

import type { TextareaProps } from './Textarea.types';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ id, disabled = false, placeholder, className, hasError, size = 'large', ...props }, forwardedRef) => {
    const classes = classNames(
      'body-200-light w-full border border-solid px-[9px] py-2 text-neutral-1000 placeholder:text-neutral-600',
      'focus:outline-1 focus:outline-solid disabled:cursor-not-allowed disabled:border-neutral-300 disabled:bg-neutral-200 disabled:text-neutral-600',
      {
        'border-neutral-400 hover:border-teal-800 focus:border-teal-800 focus:outline-teal-800': !hasError,
        'border-red-800 hover:border-red-800 focus:border-red-800 focus:outline-red-800': hasError,
      },
      // Whole lines between the padding and borders, so no line shows cut off at the bottom.
      {
        'h-[calc(3lh+1rem+2px)]': size === 'small',
        'h-[calc(5lh+1rem+2px)]': size === 'large',
      },
      className,
    );

    return (
      <textarea
        className={classes}
        disabled={disabled}
        id={id}
        placeholder={placeholder}
        ref={forwardedRef}
        {...props}
      />
    );
  },
);
